export default "__VITE_ASSET__496b333d__"